import AdminPage from "../pages/admin/AdminPage";

const adminRoutes = [
  {
    path: '/admin',
    component: AdminPage,
    exact: true,
  },
];

export default adminRoutes;